import React, { cloneElement, ReactElement, useCallback, useState } from 'react';
import uniqueId from 'lodash/uniqueId';
import { IconRetry } from '../icon/IconRetry';
import { IconButton } from '../input/IconButton';
import { Box } from '../layout/Box';

interface RetryProps {
    children: ReactElement<{ onError?: VoidFunction }>;
}

export const Retry = (props: RetryProps) => {
    const { children } = props;
    const [key, setKey] = useState(uniqueId('retry_'));
    const [shouldRetried, setShouldRetried] = useState(false);

    const onRetry = useCallback(() => {
        setShouldRetried(false);
        setKey(uniqueId('retry_'));
    }, [setKey, shouldRetried]);

    const onError = useCallback(() => setShouldRetried(true), [setShouldRetried]);

    return (
        <Box position="relative">
            {cloneElement(children, { key, onError })}
            {shouldRetried && (
                <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)">
                    <IconButton size="xl" variant="filled" onClick={onRetry}>
                        <IconRetry />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
};
